import React from "react";
import {
  Box,
  FormLabel,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const SummaryStep = ({ formData, reduxUsers, row }) => {
  const {
    name,
    description,
    ppsNumber,
    worksite,
    startDateTime,
    endDateTime,
    isPublic,
    selectedUsers = [],
  } = formData;

  const sharedUserList =
    !isPublic && reduxUsers.filter((user) => selectedUsers.includes(user.id));

  return (
    <Box>
      <FormLabel component="legend" sx={{ mb: 2 }}>
        Summary: Review before submission
      </FormLabel>

      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>
              <strong>Name</strong>
            </TableCell>
            <TableCell>{name}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Description</strong>
            </TableCell>
            <TableCell>{description}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Recorded Contact</strong>
            </TableCell>
            <TableCell>{row.fullName || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>PPS Number</strong>
            </TableCell>
            <TableCell>{ppsNumber || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Worksite</strong>
            </TableCell>
            <TableCell>{worksite || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Start Date</strong>
            </TableCell>
            <TableCell>{startDateTime || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>End Date</strong>
            </TableCell>
            <TableCell>{endDateTime || "N/A"}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <strong>Visibility</strong>
            </TableCell>
            <TableCell>{isPublic ? "Public" : "Private"}</TableCell>
          </TableRow>
          {!isPublic && (
            <TableRow>
              <TableCell>
                <strong>Shared With</strong>
              </TableCell>
              <TableCell>
                {sharedUserList.length > 0
                  ? sharedUserList.map((user) => user.fullName).join(", ")
                  : "None selected"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SummaryStep;
